<template>
  <!-- Start Main Content -->
  <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
      <div class="card">
          <h2 class="card-title">Balance Report</h2>
      </div>
      <div class="grid grid-cols-12">
          <!-- INITIALIZE CSS CLASS -->
          <div class="hidden">
              <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
              <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
              <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
              <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
              <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
          </div>
          <!-- INITIALIZE CSS CLASS -->
          <div class="tablejs sr-only size-0"></div>
          <!-- BASIC DATA TABLE -->
          <div class="col-span-full">
              <div class="card p-0">
                  <div class="p-6 space-y-4">
                      <table id="basicDataTable" class="datatable">
                          <thead>
                              <tr>
                                  <th class="bg-[#B2E8D9]">Member Name</th>
                                  <th class="bg-[#B2E8D9]">Contact</th>
                                  <th class="bg-[#B2E8D9]">Total</th>
                                  <th class="bg-[#B2E8D9]">Paid</th>
                                  <th class="bg-[#B2E8D9]">Due</th>
                                  <!-- <th class="px-3.5 py-4">Action</th> -->
                              </tr>
                          </thead>
                          <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                              <tr v-for="(item ,index)  in leadlist" :key="item.id">
                                  <td>{{item.membername}}</td>
                                  <td>{{item.phonenumber}}</td>
                                  <td>{{item.total}}</td>
                                  <td>{{item.paid}}</td>
                                  <td>{{item.total-item.paid}}</td>
                                
                                  <!-- <td class="px-3.5 py-4">
                                      <div class="flex items-center gap-1"> -->
                                          <!-- <button class="btn-icon btn-primary-icon-light size-7"  @click="editModal(item)"  >
                                              <i class="ri-add-line text-danger text-[13px]"></i>
                                          </button> -->

                                          <!-- <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                              <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                          </button> -->
         

                                          <!-- <button class="btn-icon btn-danger-icon-light size-7" @click="addfollowup(item)">
                                              <i class="ri-edit-2-line text-inherit text-[13px]"></i>  -->
                                              <!-- Change the icon here -->
                                          <!-- </button> -->


                                      <!-- </div> -->
                                  <!-- </td> -->

                              </tr> 
                          </tbody>
                      </table>
                  </div>
                  <!-- Prism Code -->
               
                  <!-- Prism Code -->
              </div>
          </div>
          <!-- BORDERED SELECTION DELETION DATA TABLE -->
          
      </div>
  </div>
  <!-- End Main Content -->

 
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'BalanceReport',
components: {

} ,
mounted(){
this.getBasics();
},
data() {
return { 
   leadlist:[], 
   datatable:null, 
   employees:[]
    
}

}, 
methods:{
    
async getBasics() {
     var self=this;
       axios.post('getbalancereport').then(function (response) {
                self.leadlist=response.data.lead;
                self.employees=response.data.userDetails;
              }).then(()=>{ 
                  self.datatable= $(".datatable").DataTable({
                          "paging": true,
                          "ordering": true,  
                          "autoWidth": false,
                          dom: 'Bfrtip', 
                            buttons: [
                              {
                                extend: 'excelHtml5',
                                title: 'Excel',
                              },
                            ],  
                         });
            
                  });;
}, 

}
}
</script>
